/*!
 * @huamios-js-framework v1.0.0
 * (c) 2020-2020 TaoHuang
 */
// 'ParseError' | 'InvalidRequest' | 'MethodNotFound' | 'InvalidParams' | 'InternalError,
const JsonRpcError = {
    ParseError: {
        code: -32700,
        message: 'Parse error',
    },
    InvalidRequest: {
        code: -32600,
        message: 'Invalid Request',
    },
    MethodNotFound: {
        code: -32601,
        message: 'Method not found',
    },
    InvalidParams: {
        code: -32602,
        message: 'Invalid params',
    },
    InternalError: {
        code: -32603,
        message: 'Internal error',
    },
};

class JsonRpcResponseBuilder {
    constructor() {
        this._jsonrpc = '2.0';
    }
    id(id) {
        this._id = id;
        return this;
    }
    result(result) {
        this._result = result;
        return this;
    }
    error(error) {
        this._error = error;
        return this;
    }
    build() {
        return {
            jsonrpc: this._jsonrpc,
            result: this._result,
            error: this._error,
            id: this._id,
        };
    }
}
class JsonRpcRequestBuilder {
    constructor() {
        this._jsonrpc = '2.0';
    }
    id(id) {
        this._id = id;
        return this;
    }
    method(method) {
        this._method = method;
        return this;
    }
    params(params) {
        this._params = params;
        return this;
    }
    build() {
        return {
            jsonrpc: this._jsonrpc,
            method: this._method,
            params: this._params,
            id: this._id,
        };
    }
}
class JsonRpcErrorBuilder {
    code(code) {
        this._code = code;
        return this;
    }
    message(message) {
        this._message = message;
        return this;
    }
    data(data) {
        this._data = data;
        return this;
    }
    build() {
        return {
            code: this._code,
            message: this._message,
            data: this._data,
        };
    }
}
JsonRpcErrorBuilder.ERROR = JsonRpcError;
class JsonRpcSerialize {
    static encode(data) {
        return JSON.stringify(data);
    }
    static decode(data) {
        return JSON.parse(data);
    }
}
function generateUUID() {
    return new Array(4)
        .fill(0)
        .map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16))
        .join('-');
}

export { JsonRpcErrorBuilder, JsonRpcRequestBuilder, JsonRpcResponseBuilder, JsonRpcSerialize, generateUUID };
